import axios from 'axios';
import WolfConnectRoutes from './../constants/WolfConnectRoutes';
import {
    fetchingExtranetUrl,
    fetchExtranetUrlSuccess,
    fetchExtranetUrlFailed,
} from './../actions/WolfConnectActions';

import { getHeaders } from './CommonFunctions';

export { getWcUrl };

function getWcUrl(lwt, callback) {

    let headers = getHeaders();
    return dispatch => {
        dispatch(fetchingExtranetUrl());
        axios
            .get(WolfConnectRoutes.WOLFCONNECT_GET_EXTRANET + lwt.cid, { headers })
            .then(response => {
                let url = `//${response.data.WcHost}`;
                dispatch(fetchExtranetUrlSuccess());
                callback((lwt.wc) ? `${url}/LoginSuccess.aspx` : `${url}/Login.aspx`);
            })
            .catch(err => {
                dispatch(fetchExtranetUrlFailed(err));
                callback(null);
            });
    };
}
